var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-gallery"},[_c('viewer',{staticClass:"images-list",class:{['box-margins']:!!_vm.boxMargins},attrs:{"images":_vm.images}},_vm._l((50),function(i){return _c('img',{key:i,attrs:{"src":'/static/images/gallery/photo-'+i+'.jpg',"alt":"gallery image"}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }